var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 16.6562C18.0312 16.8125 18.0312 17.0625 17.875 17.1875L17.1562 17.9062C17.0312 18.0625 16.7812 18.0625 16.625 17.9062L12.8438 14.125C12.7812 14.0312 12.75 13.9375 12.75 13.8438V13.4375C11.5938 14.4062 10.125 15 8.5 15C4.90625 15 2 12.0938 2 8.5C2 4.9375 4.90625 2 8.5 2C12.0625 2 15 4.9375 15 8.5C15 10.125 14.375 11.625 13.4062 12.75H13.8125C13.9062 12.75 14 12.8125 14.0938 12.875L17.875 16.6562ZM8.5 13.5C11.25 13.5 13.5 11.2812 13.5 8.5C13.5 5.75 11.25 3.5 8.5 3.5C5.71875 3.5 3.5 5.75 3.5 8.5C3.5 11.2812 5.71875 13.5 8.5 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ba647858999f5f3437627f31e206ff46.svg";
export { ForwardRef as ReactComponent };